import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Form, FormGroup, Label, Input, FormText, Spinner } from 'reactstrap';
import tabletImg from '../../../assets/img/icons/common/tablet.png';
import traditionalDeviceImg from '../../../assets/img/icons/common/traditional.png';
import { DeviceTypeStorageKey, DefaultRegionStorageKey } from '../../../constants/localStorage';
import { useAPIContext } from '../../../utilities/Contexts/DCGAutomationPagesContextProvider';
import { setUpUser } from '../../../utilities/orgPanelApiCalls';
import { errorToast, successToast } from '../../../constants/toast';
import { getAutomationDataFromLocalStorage, markAutomationCompleted } from '../../../utilities/getAutomationDataFromLocalStorage';
import DCGToastMessage from '../../../components/ToastMessage/DCGToastMessage';
import { useNavigate } from "react-router-dom";
import { DcgAutomation } from '../../../constants/onboardingVersions';
import { useStore, toastToggleCallback, makeToast } from '../../../utilities/appStore';

const SelectDeviceTypePageContent = () => {
    const { navigateToPage } = useAPIContext();
    let toast = useStore((state) => state.toast);
    const navigate = useNavigate();
    const country = parseInt(localStorage.getItem(DefaultRegionStorageKey));

    const [selectedOption, setSelectedOption] = useState(() => {
        const selectedOption = localStorage.getItem(DeviceTypeStorageKey);
        return selectedOption || null;
    });
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (selectedOption) {
            localStorage.setItem(DeviceTypeStorageKey, selectedOption);
        }

        if (country === 2) {
            setSelectedOption("device");
        }

        //This is a separate check because setting state is not synchronous. So you can end up setting the value, but reading the previous state because state hasn't updated yet.
        if (selectedOption === "device" && country === 2) {
            handleSubmit({
                preventDefault: () => { },
                target: {
                    value: "device",
                },
            }); //fake event args to call handleSubmit
        }
    }, [selectedOption]);

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (selectedOption === "tablet") {
            navigateToPage("createSubscription");
        } else {
            setIsLoading(true);
            let dataModel = getAutomationDataFromLocalStorage();
            if (!dataModel) {
                setIsLoading(false);
                navigateToPage("selectRole");
                return;
            }
            dataModel.isTraditional = true;
            dataModel.isDcgAutomation = true;
            var result = await setUpUser(dataModel);
            setIsLoading(false);
            if (result.status > 299) {
                makeToast(`Failed to create Parent Org - ${result.data.substring(0, 100)}`, errorToast);
            }
            if (result.status <= 299) {
                markAutomationCompleted(`/${DcgAutomation}/traditionalDeviceConfirmation`);
                navigate(`/${DcgAutomation}/traditionalDeviceConfirmation`);
            }
        }
    };
    return (
        <>
            {toast?.display && <DCGToastMessage isOpen={true} Message={toast?.message} Type={toast.type} ToggleCallback={toastToggleCallback} />}
            {isLoading && <Container className="text-center"><Spinner /></Container>}
            {!isLoading && <Container className="text-center">
                <Form onSubmit={handleSubmit}>
                    <FormGroup tag="fieldset">
                        {country === 1 && (
                            <Row className="my-4">
                                {/* First Radio Option */}
                                <Col>
                                    <FormGroup check>
                                        <Label check>
                                            <img
                                                src={tabletImg}
                                                alt="Tablet"
                                                style={{ width: '100px', display: 'block', margin: '0 auto 10px' }}
                                            />
                                            <Row>
                                                <Col sm='1'>
                                                    <Input
                                                        type="radio"
                                                        name="deviceOption"
                                                        value="tablet"
                                                        checked={selectedOption === "tablet"}
                                                        onChange={handleOptionChange}
                                                    />{' '}
                                                </Col>
                                                <Col className="pl-0">
                                                    <FormText>I'm using my own IOS or Android tablet which requires a recurring license subscription.</FormText>
                                                </Col>
                                            </Row>
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}
                        <Row className="my-4">
                            {/* Second Radio Option */}
                            <Col>
                                <FormGroup check>
                                    <Label check>

                                        <img
                                            src={traditionalDeviceImg}
                                            alt="DateCodeGenie Device"
                                            style={{ width: '100px', display: 'block', margin: '0 auto 10px' }}
                                        />
                                        <Row>
                                            <Col sm='1'>
                                                <Input
                                                    type="radio"
                                                    name="deviceOption"
                                                    value="device"
                                                    checked={selectedOption === "device"}
                                                    onChange={handleOptionChange}
                                                />{' '}
                                            </Col>
                                            <Col className="pl-0">
                                                <FormText>I purchased a DateCodeGenie X Series, Lite, or Fit device that does not require a subscription.</FormText>
                                            </Col>
                                        </Row>
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    </FormGroup>

                    <Button disabled={selectedOption === null} color="primary">
                        Next
                    </Button>
                </Form>
            </Container>
            }
        </>
    );
};

export default SelectDeviceTypePageContent;
